import React, { useState, useRef } from 'react';

import getItemName from './utils/getItemName';
import getGachapon from './utils/getGachapon';
import Tooltip from './Tooltip';

export default ({ id }) => {
  const ref = useRef();
  const [tooltip, setTooltip] = useState(false);
  const gachapons = getGachapon(id).map(name => <div>{name}</div>);
  const hasGachapons = gachapons.length > 0;

  return (
    <label
      ref={ref}
      onMouseEnter={() => setTooltip(true)}
      onMouseLeave={() => setTooltip(false)}
    >
      {getItemName(id)}
      {hasGachapons && <span className="text-danger">{' ● '}</span>}
      {hasGachapons && tooltip && (
        <Tooltip anchor={ref.current}>{gachapons}</Tooltip>
      )}
    </label>
  );
};
